module.exports = __webpack_public_path__ + "static/media/zy.dbdfe31d.png";